"use strict";
exports.__esModule = true;
var MediaModel = /** @class */ (function () {
    function MediaModel(data) {
        this.url = data.url;
        this.sort = data.sort;
        this.createdAt = data.createdAt;
        this.extension = data.extension;
        this.hash = data.hash;
        this.id = data.id;
        this.mimeType = data.mimeType;
        this.name = data.name;
        this.size = data.size;
        this.updatedAt = data.updatedAt;
    }
    MediaModel.prototype.hydrate = function (data) {
        for (var prop in data) {
            if (data.hasOwnProperty(prop) && MediaModel.AVAILABLE_PROPS.includes(prop)) {
                this[prop] = data[prop];
            }
            else {
                throw new Error("Provided unknown property to media.hydrate(): " + prop);
            }
        }
        return this;
    };
    MediaModel.AVAILABLE_PROPS = [
        'url',
        'sort',
        'createdAt',
        'extension',
        'hash',
        'id',
        'mimeType',
        'name',
        'size',
        'updatedAt'
    ];
    return MediaModel;
}());
exports.MediaModel = MediaModel;
//# sourceMappingURL=media.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@qwentes/models/lib/packages/media/media.js
// module id = 160
// module chunks = 0